import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";
import { AuthCard } from "@/components/app/AuthCard";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) { setError(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <AuthCard title="Mot de passe oublié" subtitle="Saisissez votre courriel : nous vous enverrons un lien valide 1 heure.">
      {sent ? (
        <div data-testid="forgot-password-success" className="space-y-6">
          <p className="flex gap-3 rounded-md border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-300"><MailCheck className="h-5 w-5 flex-none" />{sent}</p>
          <Link to="/login" className="text-sm text-blue-400 hover:text-blue-300">Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
          <div className="space-y-2"><Label>Courriel</Label><Input type="email" required data-testid="forgot-password-email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 border-slate-700 bg-slate-900/70" /></div>
          {error && <p data-testid="forgot-password-error" className="rounded-md border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-300">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="forgot-password-submit" className="h-11 w-full bg-blue-600 text-white hover:bg-blue-500">{busy ? "Envoi…" : "Envoyer le lien"}</Button>
          <Link to="/login" className="block text-center text-sm text-slate-400 hover:text-slate-200">Retour à la connexion</Link>
        </form>
      )}
    </AuthCard>
  );
}
